import * as d3 from 'd3';
import * as stringify from "json-stringify-pretty-compact";
import * as gemini from "gemini/gemini.web";
import {default as vegaEmbed} from 'vega-embed';
import {setUserInput} from './recomControl';

function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

async function loadExamples(exampleList){
  const loadedExamples = []
  let urlPrefix = `${process.env.REACT_APP_EXAMPLE_PATH}/`
  if (window.location.href[window.location.href.length-1] !== "/") {
    urlPrefix = window.location.href + "/" + urlPrefix
  }

  for (let i = 0; i < exampleList.length; i++) {
    const example = await d3.json(urlPrefix + exampleList[i]);
    example.value = exampleList[i];
    loadedExamples.push(example)
  }

  return loadedExamples;
}

async function setupExample(exampleURL, editor, sVisEditor, eVisEditor){
  if (!editor || !sVisEditor || !eVisEditor){
    return;
  }

  //load the example setupExample
  let example = exampleURL;
  if (typeof(exampleURL)==="string") {
    example = await d3.json(exampleURL);
  }
  if (example.sSpecURL) {
    example.sSpec = await d3.json(example.sSpecURL);
  }
  if (example.eSpecURL) {
    example.eSpec = await d3.json(example.eSpecURL);
  }
  if (example.data) {
    example.sSpec.data.find(dataObj => dataObj.name === "source_0").values = copy(example.data);
    example.eSpec.data.find(dataObj => dataObj.name === "source_0").values = copy(example.data);
  }



  editor.setValue(stringify(example.gemSpecs[0], null, 2));
  sVisEditor.setValue(stringify(example.sSpec, null, 2));
  eVisEditor.setValue(stringify(example.eSpec, null, 2));

  await vegaEmbed( `#sView`, example.sSpec, {renderer: "svg", actions: false});
  await vegaEmbed( `#eView`, example.eSpec, {renderer: "svg", actions: false});

  let recoms = []
  if (!example.noRecom) {
    if (example.userInput) {
      setUserInput.bind(this, example.userInput)();
    }
    recoms = await gemini.recommend(example.sSpec, example.eSpec, example.userInput);
  }

  this.setState({
    gemSpecs: example.gemSpecs,
    currExample: example,
    recoms: recoms,
    selectedSpecIndex: 0
  });

  return example;
}

export {
  loadExamples,
  setupExample
}